<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Nouvel événement</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body is-paddingless">
      <form
        id="form-event-timeline"
        class="columns is-gapless is-clipped is-max-height-full"
        style="height: 500px; max-height: 80vh;">
        <div
          class="column is-6 is-border-right is-overflow-auto"
          style="height: auto;">
          <div class="columns is-multiline is-padding">
            <div class="column is-6">
              <r-label
                :label="`Titre de l'événement`"
                :red-check="errors.has('name')"
                :value="event.name"></r-label>
              <v-input
                id="name"
                name="name"
                @input="val => event.name = val"
                :model="event.name"
                data-vv-as="Titre de l'événement"
                v-validate="'min:2'"
                :errors-bag="errors"
                data-vv-value-path="val">
              </v-input>
            </div>
            <div class="column is-6">
              <date-picker
                :model="event.date"
                :style-version="2"
                :config="config"
                @input="event.date = $event"
                label="Date de l'événement"
                :is-required="false"></date-picker>
            </div>
            <div class="column is-12">
              <r-label
                :is-required="true"
                :label="`Description de l'événement`"
                :value="event.description"></r-label>
              <textarea
                id="description"
                name="description"
                v-model="event.description"
                label="Description de l'événement"
                data-vv-value-path="val"
                v-validate="'required'"
                data-vv-as="Description de l'événement"
                class="textarea"
                rows="7">
              </textarea>
            </div>
            <div class="column is-12">
              <div
                class="field"
                v-if="event.pictures.length">
                <r-label
                  :is-required="false"
                  :label="`Photos lié à l'événement`"
                  :value="event.pictures"></r-label>
                <view-file-list
                  :documents="event.pictures"
                  :is-array="true"
                  :can-drag="false"
                  :can-edit="true"
                  :edit-display-enabled="false"
                  @update="val => updateDocument(val, 'pictures')"></view-file-list>
              </div>
              <div
                class="field"
                v-if="event.documents.length">
                <r-label
                  :is-required="false"
                  :label="`Documents lié à l'événement`"
                  :value="event.documents"></r-label>
                <view-file-list
                  :documents="event.documents"
                  :is-array="true"
                  :can-drag="false"
                  :can-edit="true"
                  :edit-display-enabled="false"
                  @update="val => updateDocument(val, 'documents')"></view-file-list>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-6 is-sticky-0 is-self-flex-start">
          <div class="notification is-warning is-marginless">
            <p class="is-uppercase is-size-7 has-text-bold">
              <b>
                Vous pouvez ajouter un fichier à partir de cette fenêtre.
                <br>
                Les images iront dans le carrousel de l'espace acquereur. Les documents dans l'onglet "document".
              </b>
            </p>
          </div>
          <upload-file
            @upload="uploadDocument"
            :placeholder="'Sélectionner un fichier sur votre ordinateur OU faites glisser les fichiers dans cette zone'"
            :source-documents="[]"
            :is-image="true"
            :show-list="false"
            :is-square-input="true"
            :icon="'fa-upload'"
            class="is-border-bottom"></upload-file>
        </div>
      </form>
    </section>
    <div class="formActionsSticky is-bottom">
      <div class=" columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
        <div class="column is-4 is-3-widescreen is-margin-right-small">
          <a
            @click="close()"
            class="button is-light is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-4 is-3-widescreen is-margin-left-small">
          <button
            @click="submit"
            class="button is-success is-uppercase is-fullwidth has-text-white"
            type="submit">
            <span>Valider</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
const emptyEvent = {
  name: null,
  date: null,
  description: null,
  documents: [],
  pictures: []
}
export default {
  name: 'EventModal',
  components: {
    ViewFileList: () => import('@/components/adv/ViewFileList')
  },
  props: {
    source: {
      type: Object
    },
    params: {
      type: Object
    }
  },
  data () {
    return {
      config: {
        enableTime: true,
        altFormat: 'j/m/Y H:i'
      },
      emptyEvent: emptyEvent,
      event: {}
    }
  },
  computed: {
    id () {
      return this.params.id
    },
    from () {
      return this.params.from
    }
  },
  created () {
    if (this.source) {
      this.event = Object.assign({}, this.source)
    } else {
      this.event = cloneDeep(this.emptyEvent)
    }
  },
  methods: {
    isImage (item) {
      let ext = item.path.split('.')
      return /(jpg|png|jpeg|gif)/g.test(ext[ext.length - 1])
    },
    updateDocument (documents, key) {
      for (let document of documents) {
        if ('destination' in document) {
          document.destination = []
        }
        let idx = this.event[key].findIndex(x => {
          return x.fus_id === document.fus_id
        })
        this.event[key].splice(idx, 1, document)
      }
    },
    async uploadDocument (documents) {
      for (let document of documents) {
        let isImage = await this.isImage(document)
        if (isImage) {
          this.event.pictures.push(document)
        } else {
          this.event.documents.push(document)
        }
      }
    },
    close () {
      this.$emit('close')
    },
    async submit () {
      const formIsValid = await this.$validator.validateAll()
      if (!formIsValid) {
        this.$toasted.global.danger('Veuillez renseigner les champs obligatoires')
        return
      }
      try {
        if (this.source) {
          let { data } = await this.$api.put(`/${this.from}/${this.id}/timeline`, this.event.pk, this.event)
          this.$toasted.global.success('Événement modifié.')
          this.$emit('sendInfo', data)
        } else {
          let { data } = await this.$api.post(`/${this.from}/${this.id}/timeline`, this.event)
          this.$toasted.global.success('Événement créé.')
          this.$emit('sendInfo', data)
        }
      } catch (err) {
        this.$toasted.global.danger('Erreur.')
        console.log(err)
      } finally {
        this.close()
      }
    }
  }
}
</script>
